/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useState, useEffect, useRef } from 'react';
import { useSwipeable } from 'react-swipeable'
import { useTheme } from '~/contexts/ThemeContext';
import { altText, imgSize, imgCDN } from '~/utils/helpers'
import VideoBg from '~/components/video/bg'

import { aria_btn, zoom_plus } from "~/styles/app.module.scss"
import { indicate, ind_dot, curr } from "~/styles/shared/img_grid.module.scss";
import * as styles from "~/styles/pdp/img_strip.module.scss";


const ImgStrip = ({ media, handle, title }) => {
  const { setFreeze, isMobile, isTouches } = useTheme()

  const [currImg, setCurrImg] = useState(media[0])
  const [zoomImg, setZoomImg] = useState(false)
  const [pos, setPos] = useState(0)
  const imgRef = useRef(null)
  const zoomRef = useRef(null)
  const zoomImgRef = useRef(null)

  const total = media && (media.length - 1)

  const imgsrc_size = (item) => { 
    return !isMobile ? imgSize(item.src,1800) : imgSize(item.src,1100)
  }

  const vid_opts = (item) => {
    const options = {
      autoplay: true,
      controls: false,
      children: ['mediaLoader', 'posterImage'],
      setPlaysinline: true,
      playsinline: true,
      muted: true,
      loop: true,
      sources: item.sources.filter(x => x.mimeType !== 'application/x-mpegURL').map((x) => {
        return {src: x.url, type: x.mimeType}
      })
    }
    return options
  }

  const swipers = useSwipeable({
    onSwiping: (e) => {
      if (!isTouches) return
    },
    onSwipedLeft: (e) => {
      if (!isTouches ) return
      if (pos === total) return

      if (pos + 1 <= total) {
        setCurrImg(media[pos + 1])
        setPos(pos + 1)
      }
    },
    onSwipedRight: (e) => {
      if (!isTouches) return
      if (pos === 0) return
      
      if (pos - 1 >= 0) {
        setCurrImg(media[pos - 1])
        setPos(pos - 1)
      }
    },
    preventScrollOnSwipe: true,
    trackTouch: true,
    trackMouse: true,
    delta: {
      up: 1000,
      down: 1000,
    },
  });

  const handleClick = (item, index) => {
    setCurrImg(item)
    setPos(index)

    setTimeout(() => {
      if (imgRef.current) {
        imgRef.current.setAttribute('src', imgsrc_size(item))
      }
    }, 300)
  }

  const checkKey = (e) => {
    if (e.key === 'Escape') handleZoomClose()
  }

  const checkZoomClose = (e) => {
    if ( e.target.matches('img') ) return

    handleZoomClose()
  }

  const handleLoad = () => {
    if (isMobile) return
    media.filter(x => x.type === 'IMAGE').forEach(x => {
      const preimg = new Image()
      preimg.src = imgSize(x.src,1800)
    })
  }

  const handleZoom = () => {
    setFreeze(true)
    setZoomImg(currImg)

    setTimeout(() => {
      if (zoomRef.current) {
        zoomRef.current.setAttribute('on', '')
      }
    }, 100)
    setTimeout(() => {
      if (zoomImgRef.current) {
        zoomImgRef.current.setAttribute('src', imgCDN(currImg.src))
      }
    }, 300)
    window.addEventListener('keydown', checkKey);
  }

  const handleZoomClose = () => {
    setFreeze(false)
    window.removeEventListener('keydown', checkKey);

    if (zoomRef.current) {
      zoomRef.current.removeAttribute('on')
    }
    setTimeout(() => {
      setZoomImg(false)
    }, 200)
  }

  useEffect(() => {
    window.addEventListener('load', handleLoad)

    setTimeout(() => {
      if (imgRef.current) {
        imgRef.current.setAttribute('src', imgsrc_size(currImg))
      }
    }, 300)

    return () => {
      window.removeEventListener('load', handleLoad);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  return (
    <>
      <div className={styles.strip} strip-gall="">
        <div className={styles.menu_wr}>
          <div className={styles.menu}>
            {media.map( (item, index) => 
              <React.Fragment key={`stripimg_${index}`}>
                {item.type === 'IMAGE' ? (
                  <button type="button" className={styles.menu_btn} onClick={(e)=> {handleClick(item, index)}}>
                    <img 
                      src={imgSize(item.src,300)}
                      alt={altText(item.alt, title)}
                      className={styles.img}
                      width={85}
                      height={115} 
                      decode={index === 0 ? undefined : 'async'} 
                    />
                  </button>
                ) : (
                  <button 
                    type="button"
                    className={styles.menu_btn} 
                    onClick={(e)=> {handleClick(item, index)}}
                    aria-label="Show video"
                  >
                    <VideoBg 
                      options={vid_opts(item)}
                      vidclasses={`${styles.gallvid} ${styles.img}`}
                      off={false}
                    />
                  </button>
                )}
              </React.Fragment>
            )}
          </div>
        </div>
        <div className={styles.image} {...swipers}>
          {currImg && (
            <>
              {currImg.type === 'IMAGE' && (
                <div className={styles.image_show} strip-image-show="">
                  <img 
                    src={imgSize(currImg.src,700)}
                    alt={altText(currImg.alt, title)}
                    className={styles.img}
                    strip-img=""
                    width={650}
                    height={865}
                    ref={imgRef}
                  />
                </div>
              )}
              {currImg.type === 'VIDEO' && (
                <div className={styles.vid_show} strip-vid-show="">
                
                  <VideoBg 
                    options={vid_opts(currImg)}
                    vidclasses={`${styles.gallvid} ${styles.img}`}
                    off={false}
                  />
                </div>
              )}
            </>
          )}
          {isMobile && media.length > 1 && (
            <div className={indicate}>
              {media.map((x,index) => 
                <div key={`dot${index}`} className={[ind_dot, pos === index ? curr : ''].join(' ')} />
              )}
            </div>
          )}
        </div>
      </div>
      {!isMobile && (
        <div className={`${styles.zoom} ${currImg.type === 'IMAGE' ? styles.zoom_on : ''}`}>
          <button 
            type="button"
            className={[aria_btn, zoom_plus].join(' ')} 
            aria-label="See full image" 
            onClick={(e)=> {handleZoom()}}
          />
        </div>
      )}
      {zoomImg && (
        <div 
          className={styles.pdpzoom} 
          ref={zoomRef}
          onClick={(e)=> checkZoomClose(e)}
          onKeyDown={(e)=> checkKey(e)}
        >
          <button 
            type="button"
            className={[aria_btn, zoom_plus, styles.zoom_btn].join(' ')}
            aria-label="Close full image" 
            onClick={(e)=> {checkZoomClose(e)}}
          />
          <div className={styles.zoom_image}>
            <img src={imgsrc_size(zoomImg)} className={styles.zoom_img} ref={zoomImgRef} alt={`Full size: ${altText(zoomImg.alt, title)}`} />
          </div>
        </div>
      )}
    </>
  )
}

export default ImgStrip





